export default __webpack_public_path__ + "assets/4caebeab5a6dd63150e75a528e83f198.png";